import { render, staticRenderFns } from "./WhatsAppChat.vue?vue&type=template&id=a2865ee2&scoped=true&"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js&"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppChat.vue?vue&type=style&index=0&id=a2865ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2865ee2",
  null
  
)

export default component.exports